/**
 * Monster Roles for tactical encounter generation
 * 
 * Roles help create balanced, interesting encounters by ensuring
 * variety in monster capabilities (tanks, damage dealers, support, etc.)
 * 
 * Roles are pre-assigned to monsters in srd_5e_monsters.json
 */

export const ROLES = {
  brute: {
    label: 'Brute',
    icon: '🪓',
    description: 'High HP, low AC, deals heavy damage',
    color: '#c62828',
  },
  soldier: {
    label: 'Soldier',
    icon: '🛡️',
    description: 'Balanced HP and AC, reliable frontline fighter',
    color: '#1565c0',
  },
  skirmisher: {
    label: 'Skirmisher',
    icon: '⚔️',
    description: 'Mobile striker, hit-and-run tactics',
    color: '#2e7d32',
  },
  artillery: {
    label: 'Artillery',
    icon: '🎯',
    description: 'Ranged attacker, fragile but deadly from distance',
    color: '#f57c00',
  },
  controller: {
    label: 'Controller',
    icon: '🔮',
    description: 'Debuffs, area denial, crowd control',
    color: '#7b1fa2',
  },
  leader: {
    label: 'Leader',
    icon: '👑',
    description: 'Buffs allies, commands others, high value target',
    color: '#ffd600',
  },
  lurker: {
    label: 'Lurker',
    icon: '🗡️',
    description: 'Ambush predator, high burst damage from stealth',
    color: '#424242',
  },
  spellcaster: {
    label: 'Spellcaster',
    icon: '✨',
    description: 'Casts spells, versatile but fragile',
    color: '#00838f',
  },
  minion: {
    label: 'Minion',
    icon: '👤',
    description: 'Weak fodder, strength in numbers',
    color: '#9e9e9e',
  },
};

export function getRoleInfo(role) {
  return ROLES[role] || ROLES.soldier;
}
